import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { cn } from '@/lib/utils';
import { LongArrow } from '@/components/brand/long-arrow';

/** "Ver …"/"Editar …" link of the Início cards, with the brand's long arrow. */
export function HomeCardLink({
  to,
  children,
  className,
}: {
  to: string;
  children: ReactNode;
  className?: string;
}) {
  return (
    <Link
      to={to}
      className={cn(
        'group inline-flex min-h-11 w-fit items-center gap-3 text-sm font-semibold text-[#155DFC] hover:text-[#0B4AE0] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      <span>{children}</span>
      <LongArrow lineClassName="w-[22px] group-hover:w-10" />
    </Link>
  );
}
